var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
var Arrow = function (_a) {
    var className = _a.className;
    return (_jsx("svg", __assign({ width: "14", height: "8", className: className, viewBox: "0 0 14 8", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: _jsx("path", { d: "M1 0.996094L7 6.99609L13 0.996094", stroke: "#071048", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }) })));
};
export default Arrow;
//# sourceMappingURL=arrow.js.map